import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/email`;

export const emailHandlers = [
  // メールアドレスの変更リクエスト
  http.post(`${baseUrl}/reset_request`, async ({ request }) => {
    const { new_email } = (await request.json()) as Required<{
      new_email: string;
    }>;

    if (new_email === 'error@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'new_email',
              message: 'メールアドレスを正しい書式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    } else if (new_email === 'google@dummy.com') {
      return HttpResponse.json(
        {
          error_type: 'error',
          message:
            'Google連携によるサインインを行なっていただいているためメールアドレスの変更はできません。',
        },
        { status: 403 }
      );
    }

    return HttpResponse.json({ success: true });
  }),
  // トークンの有効性チェック
  http.post(`${baseUrl}/validate_token`, async ({ request }) => {
    const { token } = (await request.json()) as Required<{
      token: string;
    }>;
    if (token === 'invalidToken') {
      return HttpResponse.json(
        { error_type: 'error', message: '不正なトークンです。' },
        { status: 400 }
      );
    } else {
      return new HttpResponse(null, { status: 200 });
    }
  }),
  // メールアドレス変更実行
  http.post(`${baseUrl}/reset`, async ({ request }) => {
    const { token, password } = (await request.json()) as Required<{
      token: string;
      password: string;
    }>;
    if (token === 'errorToken') {
      return HttpResponse.json(
        { error_type: 'error', message: '認証情報が見つかりません' },
        { status: 401 }
      );
    } else if (password === 'errorPassword') {
      return HttpResponse.json(
        { error_type: 'error', message: 'パスワードが正しくありません' },
        { status: 404 }
      );
    } else {
      return HttpResponse.json({ success: true });
    }
  }),
];
